import React from "react";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import AustraliaBloreMain from "./AustraliaBloreMain";
const AustraliaBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Australia Apostille in Bangalore" />
      <AustraliaBloreMain />
    </div>
  );
};

export default AustraliaBlore;
